<h3 class="color-primary" mat-dialog-title>{{data.title}}</h3>

<div mat-dialog-content>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12 dialogBox">
					<mat-form-field style="width:100%">
						<mat-label>{{data.placeholder | translate}}</mat-label>
						<mat-select (selectionChange)="onChange($event)" [(value)]="data.data">
							<mat-option>{{data.placeholder | translate}}</mat-option>
							<mat-option *ngFor="let item of data.dataList" [value]="item._id">
								<span *ngIf="item.text">{{item.text}}</span>
								<span *ngIf="item.name">{{item.name}}</span>
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
</div>

<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{data.cancelbtn}}</button>&nbsp;
	<button mat-raised-button (click)="onYesClick()" cdkFocusInitial>{{data.confirmbtn}}</button>
</div>